<template>
  <div style="height:100%; width: 100%">
    <app-header />
    <main class="page-container">
      <visitor />
    </main>
    <!--<app-footer />-->
  </div>
</template>

<script>
import AppHeader from "../../components/AppHeader.vue";
import Visitor from "../../components/Visitor.vue";

export default {
  name: "VisitorPage",
  components: {
    AppHeader,
    Visitor
  }
};
</script>
